import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { MEMBERS_IMPORT_PATH, MEMBERS_PATH } from '../constants/routes.js';
import { getBasePath } from '../utils/getBasePath.js';

/**
 * Absolute links into People & Access, built from where the host mounted the app (embed-safe:
 * the mount point is never hardcoded).
 *
 * @returns {{ basePath: string, membersPath: string, importPath: string }}
 */
export function usePeopleAccessPaths() {
  const { pathname } = useLocation();
  const params = useParams();
  const splat = params['*'];

  return useMemo(() => {
    const basePath = getBasePath(pathname, splat);
    return {
      basePath,
      membersPath: `${basePath}/${MEMBERS_PATH}`,
      importPath: `${basePath}/${MEMBERS_IMPORT_PATH}`,
    };
  }, [pathname, splat]);
}
